import React from "react";
import "./SlidingTextBackground.css";
const SlidingTextBackground = ({ text, classes = "" }) => {
  const fillArray = (arr) => {
    let result = [];
    for (let i = 0; i < arr.length; i++) {
      result.push(i + 1);
    }
    return result;
  };

  const rows = fillArray(new Array(30));
  const cols = fillArray(new Array(30));
  const getAnim = (i) => (i % 2 === 0 ? " slide-right " : " slide-left ");
  const getTextStyle = (i) => (i % 2 === 0 ? "bg-bold" : "bg-outline");
  return (
    <div
      className={
        classes +
        " absolute sliding-text w-full transform -translate-x-96 -translate-y-32 -skew-y-[18deg] z-10 font-secondary font-black "
      }
    >
      {rows.map((e, i) => (
        <h2
          // style={{ "--slide-duration": i % 2 === 0 ? "20s" : "12s" }}
          className={"w-full relative text-3xl " + getAnim(i) + getTextStyle(i)}
          key={i}
        >
          {cols.map((_, j) => (
            <span className="text-zinc-600 m-2" key={`${i}${j}`}>
              {i % 2 === 0 ? text[0] : text[1]}
            </span>
          ))}
        </h2>
      ))}
    </div>
  );
};

export default SlidingTextBackground;
